import _axios from 'axios';
import jwt from 'jsonwebtoken';
import { v4 as uuidv4 } from 'uuid';

class NodeDataService {
  constructor () {
    this.axios = _axios;
    this.api = this.axios.create({
      baseURL: ''
    })

    this.jwtToken = jwt.sign(
      {
        _id: uuidv4()
      }, process.env.REACT_APP_NODE_API_CLIENT_SECRET);

    // Request interceptor
    this.api.interceptors.request.use(
      config => {
        config.headers['x-access-token'] = this.jwtToken;
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )

    // Response interceptor
    this.api.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.clear();
           // we can initiate logout here
          }
        }

        return Promise.reject(error)
      }
    )
  }

 getExamList(filterStr) {
  return this.api({
    url: `/api/v1/usDataPortal/getExamList?filterBy=${filterStr}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => response.data)
 }

 // Log payment status details for a user
 logPaymentStatus(allPaymentData) {
  return this.api({
    url: '/api/v1/usDataPortal/logPaymentStatus',
    method: 'post',
    data: JSON.stringify(allPaymentData),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => response.data)
 }
}


const instance = new NodeDataService();
  Object.freeze(instance);
  
export default instance;
